import React from 'react';
import moment from 'moment';
import Chip from '@material-ui/core/Chip';
import { useGlobalState } from '../../../state';
import PPMobileCardView from '../../../components/PPMobileCardView';

// Same labels and colours as the desktop "Payment Status" column
const dueStatus = (dueDays) => {
    if (dueDays === 1) return { label: "Due in 1 day", color: '#4caf50' };
    if (dueDays === -1) return { label: "Over due by 1 day", color: '#f44336' };
    if (dueDays > 0) return { label: "Due in " + dueDays + " days", color: '#4caf50' };
    if (dueDays < 0) return { label: "Over due by " + Math.abs(dueDays) + " days", color: '#f44336' };
    return { label: "Today", color: '#ff9800' };
};

// Card for the dashboard Payments / Receivables tables
const DueMobile = ({ data, onPayment, paymentLabel }) => {
    const [{ user }] = useGlobalState();
    const amountObj = { style: "currency", currency: user.currency, minimumFractionDigits: 2, maximumFractionDigits: 2 };
    const due = dueStatus(data.dueDays);

    const rows = [
        { label: 'Status', value: <Chip className="pp-pill" label={due.label} style={{ backgroundColor: due.color, color: 'white' }} />, inHeader: true, hideLabel: true },
        { label: 'Date', value: moment(data.date).format("DD-MM-YYYY") },
        { label: 'Amount', value: (data.totalBillValue).toLocaleString(user.locales, amountObj), bold: true },
        { label: 'Paid', value: (data.totalAmountPaid).toLocaleString(user.locales, amountObj) },
    ];

    return (
        <PPMobileCardView
            title={data.companyName}
            rows={rows}
            menuItems={[{ label: paymentLabel, onClick: onPayment }]}
        />
    );
};

export default DueMobile;
